"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.DatagridCardsView = (props) => {
    return (React.createElement("div", { className: "row" }, props.children));
};
exports.DatagridCardsView.displayName = 'DatagridCardsView';



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridCardsView.tsx
// module id = 252
// module chunks = 0